<template>
  <v-app-bar
    app
    class="ChildProfileToolbar child-profile-toolbar"
  >
    <v-btn
      icon
      class="mr-4 ml-md-0"
      @click="$emit('click:menu')"
    >
      <v-icon>{{ toggleMenuIcon }}</v-icon>
    </v-btn>
    <img
      width="30"
      height="30"
      src="https://images.growmindgrow.com/parent-site/assets/GMG.png"
      alt="GrowMindGrow logo"
      class="mr-2"
    >
    <v-app-bar-title class="child-profile-toolbar__title">
      GrowMindGrow
    </v-app-bar-title>

    <v-spacer />

    <v-toolbar-items>
      <v-btn
        v-for="action in actionsList"
        :key="action.name"
        :icon="$vuetify.breakpoint.xsOnly"
        :to="action.to"
        exact
        tile
        text
        color="grey darken-4"
        v-on="action.on"
      >
        <v-icon :left="$vuetify.breakpoint.mdAndUp">{{ action.icon }}</v-icon>
        <span class="d-none d-md-inline">{{ action.name }}</span>
      </v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ChildProfileToolbar',
  props: {
    fullSizeSideDrawer: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('children', [
      'activeChildProfile',
    ]),
    toggleMenuIcon() {
      return this.$vuetify.breakpoint.smAndUp && this.fullSizeSideDrawer ? 'menu_open' : 'menu';
    },
    actionsList() {
      if (this.activeChildProfile) {
        return [
          {
            name: 'Events',
            icon: 'event',
            to: { name: 'profile-events' },
          },
          {
            name: 'Notifications',
            icon: 'notifications',
            on: {
              click: () => this.$emit('click:notifications'),
            },
          },
        ];
      }

      return [
        {
          name: 'Add profile',
          icon: 'add',
          on: {
            click: () => this.$emit('click:add-profile'),
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.child-profile-toolbar {
  &__title::v-deep .v-app-bar-title__content {
    width: 160px;
  }
}
</style>
